import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { ServiceComboTargetClientele } from "@/Common/Models/Services/Enums/ServiceComboTargetClientele";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { ICheckable } from "@/Common/Models/UI/Inputs/ICheckable";

class ServiceDefinitionContext implements ICheckable {
    public Name: string;
    public IsCombo: boolean;
    public ComboId: number;

    public Min: number;
    public Max: number;

    public TargetedClient: ServiceComboTargetClientele;
    public IsOnline: boolean;
    public IsTeleconsultation: boolean;

    public Id: string;
    public Checked: boolean;
    public Visible: boolean;
    public Target: CheckboxTarget;

    constructor() {
        this.Name = "";
        this.IsCombo = false;
        this.IsOnline = false;
        this.IsTeleconsultation = false;

        this.Id = GuidHelper.NewGuid();
        this.Checked = false;
        this.Visible = true;
        this.Target = CheckboxTarget.Unassigned;
    }

    public static Clone(model: ServiceDefinitionContext): ServiceDefinitionContext {
        var clone: ServiceDefinitionContext = JSON.parse(JSON.stringify(model));
        return clone;
    }
}

export { ServiceDefinitionContext };
